import { render, staticRenderFns } from "./MoreManage.vue?vue&type=template&id=2251f21d&scoped=true&"
import script from "./MoreManage.vue?vue&type=script&lang=ts&"
export * from "./MoreManage.vue?vue&type=script&lang=ts&"
import style0 from "./MoreManage.vue?vue&type=style&index=0&id=2251f21d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251f21d",
  null
  
)

export default component.exports